__turbopack_context__.v({
  "dark_bg": "RacLogo-module__aWzUTq__dark_bg",
  "light_bg": "RacLogo-module__aWzUTq__light_bg",
  "logo": "RacLogo-module__aWzUTq__logo",
});
